import React from 'react'

const PrivacyPolicy = () => {
    return (
    <div className="max-w-5xl mx-auto py-16 px-6">
      <h1 className="text-3xl font-bold mb-6">
        Privacy Policy
      </h1>

      <p className="text-gray-700 text-lg leading-8">
        If any refund is approved, the amount will be credited to the customer's bank account within 5–7 business days.
      </p>
    </div>
  );
};

export default PrivacyPolicy